module.exports = __webpack_public_path__ + "img/image-080.5fa3054f.jpg";